@if (field.sequentialView && isLanding) {
  <div class="common-text-input__container-field-sequential">
    <field-sequential-header [field]="field"></field-sequential-header>
    @for (listElement of listValues | byWord:fieldTypeListExtended.findDropdown:[fieldToFind] | afOrderBy: fieldTypeListExtended.orderList:false; track $index){
      <div class="common-radio-button-list__container-survey-sequential-option"
        [ngClass]="{'common-radio-button-list__container-survey-sequential-option--error': field.error}"
        (click)="changeSelectedList(listElement)"
        [attr.disabled]="field.noEditable?true:null">
        <div class="common-button__block-button-md-checkbox">
          <button class="common-button__icon-md-checkbox"
            [ngClass]="{'common-button__icon-md-checkbox--selected': listElement.selected}"
            [disabled]="field.noEditable">
            <i class="common-icon__md"
              [ngClass]="{'lf-icon-radio-button-active': listElement.selected && !field.multiple,
                'lf-icon-step-first': !listElement.selected && !field.multiple,
                'lf-icon-check-full': listElement.selected && field.multiple,
                'lf-icon-box-inactive': !listElement.selected && field.multiple}"></i>
          </button>
        </div>
        <div class="common-radio-button-list__container-survey-sequential-option-text">
          <span class="common-radio-button-list__text-input-survey-sequential-option">
            {{listElement.text}}
          </span>
        </div>
      </div>
    }
    @if (field.error) {
      <div class="common-text-input__mandatory-tag">
        @if (field.blocker) {
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      </div>
    }
  </div>
}@else {
  <div class="common-text-input__container"
    [id]="field.id">
    <div class="common-text-input__container-box-no-hover"
      [ngClass]="{'common-text-input__container-box-no-hover--error': field.error,
        'common-text-input__container-box-disabled': field.noEditable
      }"
      [attr.disabled]="field.noEditable?true:null">
      <div class="common-text-input__container-header">
        <div class="common-text-input__block-header">
          <div class="common-text-input__label-no-cursor">
            <span class="common-text-input__text-label">{{fieldTypeListExtended.titleField}}</span>
            @if (field.required) {
              <span class="common-tag__mandatory-text-asterisk">*</span>
            }
            <div class="common-text-input__block-buttons">
              @if (field.description) {
                <tooltip-info [description]="field.description" [field]="field"></tooltip-info>
              }
              @if (field.references?.length) {
                <tooltip-law [references]="field.references" [field]="field"></tooltip-law>
              }
              @if (field.relatedInfo?.length){
                <button class="common-button__icon-sm-noborder"
                    pTooltip="{{'common.related-info'| afTranslate}}"
                    tooltipPosition="top"
                    (click)="openModalRelatedInfo(field.relatedInfo)">
                    <i class="lf-icon-search-text common-icon__md"></i>
                </button>
              }
              @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
                <tooltip-in-report [inReport]="fieldTypeListExtended.inReport"></tooltip-in-report>
              }
            </div>
          </div>
          <div class="common-text-input__buttons-right-header">
            @if (field.multiple && fieldTypeListExtended.listElementSelect.length) {
              <div class="common-badge__badge-block">
                <span class="common-badge__square-md">{{fieldTypeListExtended.listElementSelect.length}}</span>
              </div>
            }
          </div>
        </div>
        <div class="common-list__list-group min-h-[22px]">
          @if (field.multiple){
            @for (listElement of fieldTypeListExtended.listElementSelect; track $index){
              <div class="common-chips__standard"
                  [attr.disabled]="field.noEditable?true:null">
                  <span-tooltip class="common-chips__label-text"
                    [text]="listElement.text"></span-tooltip>
                  @if (!field.noEditable){
                    <button class="lf-icon-close-round common-icon__sm common-chips__icon-close"
                      (click)="addOrDeleteSelectedValue(listElement)"></button>
                  }
              </div>
            }
          }@else {
            <div class="common-text-input__block-selected-item"
              [ngClass]="{'common-text-input__block-selected-item--with-value': fieldTypeListExtended.selectItemName && !field.noEditable}">
              <span-tooltip class="common-text-input__selected-option"
                  [attr.disabled]="field.noEditable?true:null"
                  [text]="fieldTypeListExtended.selectItemName"></span-tooltip>
              @if (fieldTypeListExtended.selectItemName && !field.noEditable) {
                <button class="common-text-input__icon-clean-input"
                    (click)="addOrDeleteSelectedValue()">
                    <i class="lf-icon-close-thick common-icon__sm"></i>
                </button>
              }
            </div>
          }
        </div>
      </div>
      <div class="common-dropdown-list__inner-list-block">
        @if(!field.hideSearch){
          <div class="common-dropdown-list__user-list-container-header common-dropdown-list__user-list-container-header--all-width">
            <div [ngClass]="isLanding?'common-search__container-white':'common-search__container-tonal'">
              <div class="common-search__container-input-text">
                <input type="search"
                  class="common-search__input-text"
                  [(ngModel)]="fieldTypeListExtended.findDropdown"
                  placeholder="{{'common.search-item' | afTranslate}}">
              </div>
              <div class="common-search__block-button-search">
                @if(fieldTypeListExtended.findDropdown){
                  <button class="common-button__icon-xs-noborder"
                    (click)="resetSearch()">
                    <i class="lf-icon-close-thick common-icon__sm"></i>
                  </button>
                }
                <div class="h-[22px]"
                    ngClass="{{fieldTypeListExtended.findDropdown?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'}}"></div>
                <button class="common-button__icon-sm-noborder"
                [ngClass]="{'common-button__icon-sm-noborder--no-active':!fieldTypeListExtended.findDropdown}">
                    <i class="lf-icon-search common-icon__md"></i>
                </button>
              </div>
            </div>
          </div>
        }
        <ul class="common-dropdown-list__list-item-extended"
          [ngClass]="{'common-dropdown-list__list-item-extended--more-items': listValues?.length > 10}">
          @if (field.multiple && listValues?.length > 10){
            <li class="common-dropdown-list__item-value common-dropdown-list__item-value--all"
                (click)="toggleAll()"
                [attr.disabled]="field.noEditable?true:null">
                <div class="common-button__block-button-md-checkbox">
                  <button class="common-button__icon-md-checkbox"
                    [ngClass]="{'common-button__icon-md-checkbox--selected': fieldTypeListExtended.markAll}"
                    [disabled]="field.noEditable">
                    <i class="common-icon__md"
                      ngClass="{{fieldTypeListExtended.markAll?'lf-icon-check-full':'lf-icon-box-inactive'}}"></i>
                  </button>
                </div>
                <span-tooltip class="common-dropdown__list-text-title"
                  [ngClass]="{'common-dropdown__list-text-title--disabled': field.noEditable}"
                  [text]="'common.toggle-all' | afTranslate">_Marcar/desmarcar todas las opciones</span-tooltip>
            </li>
          }
          @for (listElement of listValues | byWord:fieldTypeListExtended.findDropdown:[fieldToFind] | afOrderBy: fieldTypeListExtended.orderList:false; track $index){
            <li class="common-dropdown-list__item-value"
              (click)="changeSelectedList(listElement)"
              [attr.disabled]="field.noEditable?true:null">
              <div class="common-button__block-button-md-checkbox">
                <button class="common-button__icon-md-checkbox"
                  [ngClass]="{'common-button__icon-md-checkbox--selected': listElement.selected}"
                  [disabled]="field.noEditable">
                  <i class="common-icon__md"
                    [ngClass]="{'lf-icon-radio-button-active': listElement.selected && !field.multiple,
                      'lf-icon-step-first': !listElement.selected && !field.multiple,
                      'lf-icon-check-full': listElement.selected && field.multiple,
                      'lf-icon-box-inactive': !listElement.selected && field.multiple}"></i>
                </button>
              </div>
              <p class="common-dropdown__list-text-title"
                [ngClass]="{'common-dropdown__list-text-title--disabled': field.noEditable}">{{listElement.text}}</p>
            </li>
          }
        </ul>
      </div>
    </div>
    @if (field.error) {
      <div class="common-text-input__mandatory-tag">
        @if (field.blocker) {
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      </div>
    }
  </div>
}
